import React from 'react';
import DataVendorForm from "../../../components/data_vendors/DataVendorForm";
import { useHistory, useRouteMatch } from 'react-router';
import {useTranslation} from "react-i18next";
import { useCreateDataVendorMutation, useGetDataVendorReferencesQuery } from '../../../api/dataVendorApiSlice';

function DataVendorsNew(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const {data: formRefValues } = useGetDataVendorReferencesQuery();
  const [createDataVendor] = useCreateDataVendorMutation()
  const onSubmit = (data) => {
    createDataVendor(data).unwrap()
      .then(payload => {
        history.push(`/data_vendors/${payload.slug}`)
      })
      .catch(error => {})
  }
  const handleCancel = () => history.push('/data_vendors')

  return (
    <DataVendorForm
      mainTitle={t("menu.data_vendors")}
      subTitle={t("new")}
      formRefValues={formRefValues}
      onSubmit={onSubmit}
      onCancel={handleCancel}
    />
  )
}

export default DataVendorsNew
